import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { JETPACK_CONFIG } from "../../../utils/routes/routes";
import Logo from "../../../components/Logo";
import { LinksSidebar } from "../Sidebar/LinksSidebar";
import { buildPathWithTrackingId } from "../../../utils/routing/routingUtils";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";

export const MobileHeader = () => {
  const history = useHistory();
  const { accountToDisplay } = useAccountToDisplaySelector();

  const [showMenu, setShowMenu] = useState(false);

  return (
    <div
      className={`mobile-menu-container d-block d-lg-none ${showMenu ? "open-mobile-menu-container" : ""}`}
    >
      <div className="d-flex align-items-center position-relative logo-wrapper">
        <Logo
          onClick={() =>
            history.push(
              buildPathWithTrackingId(
                JETPACK_CONFIG,
                accountToDisplay?.trackingID
              )
            )
          }
        />
        <div className="ml-auto px-2 " style={{ height: 30 }}>
          <FontAwesomeIcon
            id="mobile-menu"
            icon={showMenu ? faXmark : faBars}
            className="h-100"
            onClick={() => setShowMenu((showMenu) => !showMenu)}
          />
        </div>
      </div>
      {showMenu && <LinksSidebar closeSidebar={() => setShowMenu(false)} />}
      {showMenu && <div className="space-filler"></div>}
    </div>
  );
};
